"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = ActiveAddonsContainer;
var _react = _interopRequireWildcard(require("react"));
var _updateModeParam = _interopRequireDefault(require("../../utils/updateModeParam"));
var _r10SourceLibrary = require("r10-source-library");
var _NoAddons = _interopRequireDefault(require("../NoAddons"));
var _mapActiveAddons = _interopRequireDefault(require("./mapActiveAddons.js"));
var _BuyAddonsButton = _interopRequireDefault(require("../BuyAddonsButton"));
var _appConstants = require("../../appConstants");
var _Actions = require("../../actions/Actions.js");
var _ActiveAddonsListing = _interopRequireDefault(require("./ActiveAddonsListing"));
var _setIdWithinQueryParam = _interopRequireDefault(require("../../utils/setIdWithinQueryParam"));
var _useConfig2 = _interopRequireDefault(require("../../hooks/useConfig"));
var _reactRedux = require("react-redux");
var _r10CommonComponents = require("r10-common-components");
var _selector = require("../../selectors/selector");
var _useTranslation = _interopRequireDefault(require("../../hooks/useTranslation"));
var _styledComponents = _interopRequireWildcard(require("styled-components"));
var _reactRouterDom = require("react-router-dom");
var _useProps2 = _interopRequireDefault(require("../../hooks/useProps"));
var _templateObject, _templateObject2, _templateObject3;
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
var Div = _styledComponents.default.div((0, _styledComponents.css)(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  display: flex;\n  justify-content: center;\n  margin: auto;\n  max-width: 1030px;\n  @media only screen and (max-width: 766px) {\n    max-width: 330px;\n  }\n  @media only screen and (min-width: 767px) and (max-width: 1116px) {\n    max-width: 680px;\n  }\n\n  & > div {\n    padding: 0;\n  }\n"]))));
var RightSide = (0, _styledComponents.default)(_r10SourceLibrary.GridColumn)(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  text-align-last: end;\n"])));
function ActiveAddonsContainer() {
  var LoaderWrapper = _styledComponents.default.div((0, _styledComponents.css)(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    width: 100%;\n    height: 50vh;\n  "]))));
  var t = (0, _useTranslation.default)();
  var history = (0, _reactRouterDom.useHistory)();
  var _useProps = (0, _useProps2.default)(),
    language = _useProps.language;
  var _useConfig = (0, _useConfig2.default)(),
    activeAddon = _useConfig.activeAddon,
    customerMSISDNString = _useConfig.customerMSISDNPlaceholderInQueryParam,
    _useConfig$activeAddo = _useConfig.activeAddon,
    jPSchema = _useConfig$activeAddo.jPSchema,
    detailsPageURL = _useConfig$activeAddo.detailsPageURL,
    statusIndicator = _useConfig$activeAddo.statusIndicator,
    unitsAliases = _useConfig.unitsAliases;
  var productId = (0, _reactRedux.useSelector)(_selector.getProductId);
  var activeAddonsList = (0, _reactRedux.useSelector)(_selector.activeAddonsMappedOptions);
  var activeAddonsUnmappedList = (0, _reactRedux.useSelector)(_selector.activeAddonsUnmapped);
  var isLoading = (0, _reactRedux.useSelector)(_selector.isActiveAddonsLoading);
  var isError = (0, _reactRedux.useSelector)(_selector.isActiveAddonsFailed);
  var dateFormat = (0, _reactRedux.useSelector)(_selector.dateFormatSelector);
  var dispatch = (0, _reactRedux.useDispatch)();
  var detailsLinkHandler = function detailsLinkHandler(id) {
    history.push("".concat(detailsPageURL, "/").concat(id));
  };
  var getActiveAddonsHandler = function getActiveAddonsHandler() {
    var queryParamWithId = (0, _setIdWithinQueryParam.default)(activeAddon.queryParam, customerMSISDNString, productId);
    dispatch((0, _Actions.fetchActiveAddons)(queryParamWithId));
  };
  (0, _react.useEffect)(function () {
    getActiveAddonsHandler();
    dispatch((0, _Actions.sendTags)({
      taggingId: 'CUSTOMER_DASHBOARD_ADDONS_1',
      taggingType: 'view',
      taggingValue: {}
    }));
  }, []);
  (0, _react.useEffect)(function () {
    var mappedData = (0, _mapActiveAddons.default)(activeAddonsUnmappedList, jPSchema, statusIndicator, unitsAliases, t, function (id, state) {
      return detailsLinkHandler(id, state);
    }, dateFormat);
    dispatch((0, _Actions.setMappedActiveAddons)(mappedData));
  }, [activeAddonsUnmappedList, language]);
  var handleEligibleAddonsVisibility = function handleEligibleAddonsVisibility() {
    dispatch((0, _Actions.sendTags)({
      taggingId: 'CUSTOMER_DASHBOARD_ADDONS_2',
      taggingType: 'link',
      taggingValue: {}
    }));
    (0, _updateModeParam.default)(history, _appConstants.MODES.sellable);
  };
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.Spacing, {
    spacingLevel: {
      bottom: 5
    }
  }, /*#__PURE__*/_react.default.createElement(Div, null, /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.GridColumn, null, /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, !isLoading && /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.Spacing, {
    spacingLevel: {
      bottom: 11
    }
  }, /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.GridRow, {
    justify: "between",
    marginBottom: 4
  }, /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.GridColumn, null, /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.Heading, {
    size: 2,
    weight: 3,
    text: t('activeAddons')
  })), ((activeAddonsList === null || activeAddonsList === void 0 ? void 0 : activeAddonsList.length) > 0 || isError) && /*#__PURE__*/_react.default.createElement(RightSide, null, /*#__PURE__*/_react.default.createElement(_BuyAddonsButton.default, {
    showEligibleAddons: handleEligibleAddonsVisibility
  })))), !isLoading && !isError && (activeAddonsList === null || activeAddonsList === void 0 ? void 0 : activeAddonsList.length) > 0 && /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.GridRow, {
    align: "center",
    justify: "between",
    noGutters: true
  }, /*#__PURE__*/_react.default.createElement("span", {
    "data-testid": "active-addon-list"
  }, /*#__PURE__*/_react.default.createElement(_ActiveAddonsListing.default, null)))), isLoading && !isError && /*#__PURE__*/_react.default.createElement(LoaderWrapper, {
    "data-testid": "activeAddons-list-loader"
  }, /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.Loader, {
    text: t('loading'),
    srText: t('loading'),
    appearance: "primary",
    size: 2
  })), (activeAddonsList === null || activeAddonsList === void 0 ? void 0 : activeAddonsList.length) == 0 && !isLoading && !isError && /*#__PURE__*/_react.default.createElement(_NoAddons.default, null), !isLoading && isError && /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.GridRow, {
    marginTop: 7,
    justify: "center"
  }, /*#__PURE__*/_react.default.createElement("div", {
    "data-testid": "error"
  }, /*#__PURE__*/_react.default.createElement(_r10CommonComponents.ErrorContent, {
    icon: "warning",
    title: t('somethingWentWrong'),
    description: t('somethingWentWrongDescription'),
    buttonText: t('retryButton'),
    iconSize: 1,
    buttonAction: function buttonAction() {
      return getActiveAddonsHandler();
    },
    titleTestId: "activeAddons-list-error-timeout-title",
    descriptionTestId: "activeAddons-list-error-timeout-description",
    actionButtonTestId: "activeAddons-list-error-retryButton"
  })))))));
}